// «Финансы»: analytics-service через прокси статистики erp-backend (доступ — только руководителю логистики).
import { useAxiosCreate } from '@/backend/utils.js'

const api = useAxiosCreate('api')

export async function fetchFinance(month) {
  const { data } = await api.get('statistics/team-goals', { params: month ? { month } : {} })
  return data
}

export async function fetchFinancePlan(month) {
  const { data } = await api.get('statistics/team-goals/plan', { params: month ? { month } : {} })
  return data
}

export async function saveFinancePlan(payload) {
  const { data } = await api.put('statistics/team-goals/plan', payload)
  return data
}
